export default {"src":"/_next/static/media/icon-success-fill.9f25d542.svg","height":16,"width":16};